type Callback = (data?: any) => void

class PubSubBroker {
    private topics: Record<string, Callback[]> = {}

    subscribe(topic: string, callback: Callback) {
        if (!this.topics[topic]) {
            this.topics[topic] = []
        }
        this.topics[topic].push(callback)
        return {
            unsubscribe: () => {
                this.topics[topic] = this.topics[topic].filter(cb => cb !== callback)
            }
        }
    }

    publish(topic: string, data?: any) {
        if (!this.topics[topic]) return
        this.topics[topic].forEach(callback => callback(data))
    }
}

export const pubSubBroker = new PubSubBroker()
